export default __webpack_public_path__ + "static/media/Ballroll_00129.0dde366b.png";